import * as React from "react";

import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

interface Props {
    index?: number;
    readonly: boolean;
    questionnaireKey: string;
}

export const GeneralQuestionsSection: React.FunctionComponent<Props> = (props) => {
    return (
        <AccordionQuestionnaireSection
            id="GeneralQuestions"
            title="General Questions"
            index={props.index}
        >
            <MultiButtonQuestion
                questionConfig={({
                    id: "HepatitisBLeaflet",
                    questionText: "If known as a true non-responder to Hepatitis B, has an advice leaflet been given?"
                })}
                readonly={props.readonly}
                mandatory
                values={["Yes", "No", "N/A"]}
            />
            <MultiButtonQuestion
                questionConfig={({
                    id: "NeedlestickBbvReporting",
                    questionText: "Has the Needlestick / BBV incident reporting process been discussed?"
                })}
                readonly={props.readonly}
                mandatory
                values={["Yes", "No", "N/A"]}
            />
            <MultiButtonQuestion
                questionConfig={({
                    id: "Covid19Discussion",
                    questionText: `Have you asked about COVID-19 vaccination and had an exploratory discussion and
provided advice if not yet vaccinated?`
                })}
                readonly={props.readonly}
                mandatory
            />
        </AccordionQuestionnaireSection>
    );
};
